<template>
  <div class="ranking">
    <ba-ranking />
  </div>
</template>

<script>
import BaRanking from '@/components/ranking/Pane'

export default {
  name: 'Ranking',
  components: {
    BaRanking
  }
}
</script>

<style lang="scss" scoped>
.ranking {
}
</style>
